import React, { useState } from 'react'
import './DashboardStyle.css'
import ReactApexChart from 'react-apexcharts';
import { Link, useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Pagination, Navigation } from 'swiper';
import CardDs from '../../../components/CardDs/CardDs';
import MnRequest from '../../../components/MnRequest/MnRequest';
import SessionDetailpopup from '../../../components/Popups/SessionDetailpopup/SessionDetailpopup';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { acceptMentorRequest, adminData, clearState, clearUsers, getAllMentorRequests, getDashBoardAdmin, getTopRatedMentors, rejectMentorRequest } from '../../../reducer/adminSlice';
import DatanotFound from '../../../components/DatanotFound/DatanotFound';
import PageLoader from '../../../components/loaders/PageLoader/PageLoader';
import ErrorToast from '../../../components/Toast/ErrorToast';
import SuccessToast from '../../../components/Toast/SuccessToast';
import moment from 'moment';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css'

const Dashboard = () => {

  const navigationNextRefds = React.useRef(null);
  const navigationPrevRefds = React.useRef(null);

  var totalMenteeOptions = {
    chart: {
      toolbar: {
        show: false
      }
    },
    series: [{
      name: "Mentors",
      data: [20, 24, 26, 28, 30, 40]
    }],
    xaxis: {
      labels: {
        show: false,
      }
    },
    yaxis: {
      labels: {
        show: false,
      }
    },
    dataLabels: {
      enabled: false
    },
    fill: {
      colors: ['#ccc']
    },
    colors: ['#000'],
    stroke: {
      curve: 'smooth',
    }
  }
  
  var totalMentorOptions = {
    chart: {
      toolbar: {
        show: false
      }
    },
    series: [{
      name: "Mentees",
      data: [10, 14, 14, 14, 19, 30]
    }],
    xaxis: {
      labels: {
        show: false,
      }
    },
    yaxis: {
      labels: {
        show: false,
      }
    },
    dataLabels: {
      enabled: false
    },
    fill: {
      colors: ['#ccc']
    },
    colors: ['#000'],
    stroke: {
      curve: 'smooth',
    }
  };

  const currMonth = moment().month();

  const navigationNextRefNew = React.useRef(null);
  const navigationPrevRefNew = React.useRef(null);

  //Call States
  const [totalDates, setTotalDates] = useState([]);
  const [totalCalls, setTotalCalls] = useState([]);
  const [completedCalls, setCompletedCalls] = useState([]);
  const [cancelledCalls, setCancelledCalls] = useState([]);
  const [rescheduledCalls, setRescheduledCalls] = useState([]);
  const [unattendedCalls, setUnttendedCalls] = useState([]);

  //Filter states
  const [duration, setDuration] = useState("week");
  const [month, setMonth] = useState(currMonth);
  const [week, setWeek] = useState(moment().format("YYYY-MM-DD"));

  //Toast states
  const [isShowError, setIsShowError] = useState(false);
  const [errMessage, setErrMessage] = useState("");
  const [isShowSuccess, setIsShowSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const { isRequestsFetching, isLoaderFetching, isDashboardFetching, isTopRatedMentorFetching, isSuccess, isError, errorMessage, mentorRequests, dashboardData, topMentorRatings } = useSelector(adminData);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleAcceptRequest = (id) => {
    dispatch(acceptMentorRequest(id));
};

const handleRejectRequest = (id) => {
    dispatch(rejectMentorRequest(id));
};

const handleGraphPagination = (flow, duration) => {
  if(duration === "week") {
    if(flow === "prev") {
      setWeek(totalDates[0]);
    };
    if(flow === "next") {
      setWeek(moment(totalDates[totalDates?.length - 1]).add(8, 'days').format("YYYY-MM-DD"));
    };
  } 
  if(duration === "month") {
    if(flow === "prev") {
      setMonth(prev => prev - 1);
    };
    if(flow === "next") {
      setMonth(prev => prev + 1);
    };
  }
};

  useEffect(() => {
    dispatch(getAllMentorRequests({}));
    // dispatch(getDashBoardAdmin());
    dispatch(getTopRatedMentors());
  },[]);

  useEffect(() => {
    if(dashboardData?.callsGraph?.length > 0) {
      setTotalDates(dashboardData?.callsGraph?.map(item => moment(item?.date).format("YYYY-MM-DD")))
      setTotalCalls(dashboardData?.callsGraph?.map(item => item?.total));
      setCompletedCalls(dashboardData?.callsGraph?.map(item => item?.completed));
      setCancelledCalls(dashboardData?.callsGraph?.map(item => item?.cancelled));
      setRescheduledCalls(dashboardData?.callsGraph?.map(item => item?.rescheduled));
      setUnttendedCalls(dashboardData?.callsGraph?.map(item => item?.noshow));
    }
  },[dashboardData]);

  useEffect(() => {
    if(duration === "week") dispatch(getDashBoardAdmin({duration, week}));
    if(duration === "month") dispatch(getDashBoardAdmin({duration, month}));
    if(duration === "year") dispatch(getDashBoardAdmin({duration}));
  },[duration, month, week])

  useEffect(() => {
    if(isSuccess) {
      dispatch(getAllMentorRequests({}));
      setIsShowSuccess(true);
      setSuccessMessage("Success!");
      dispatch(clearState());
    }
  },[isSuccess]);

  useEffect(() => {
    if(isError) {
      setIsShowError(true);
      setErrMessage(errorMessage);
      dispatch(clearState());
    }
  },[isError]);

// Chart options
const options = {
  chart: {
    type: 'bar',
    height: 250,
    stacked: false // Set stacked to false to allow grouping
  },
  fill: {
    colors: ["#0E77D3"]
  },
  stroke: {
    width: 2,
  },
  plotOptions: {
    bar: {
      horizontal: false,
      columnWidth: '25%', // Adjust the width of the bars
      grouped: true, // Set grouped to true to group the bars
      borderRadius: "4",
    }
  },
  series: [
    {
      name: '',
      data: totalCalls
    }
  ],
  xaxis: {
    categories: totalDates,
    labels: {
      formatter: function(value) {
        if(duration === "week") return moment(value).format("DD MMM");
        if(duration === "month") return moment(value).format("DD");
        if(duration === "year") return moment(value).format("MMM");
      }
    }
  },
  yaxis: {
    tickAmount: 5,
    min: function(min) {
      return min * 0.9;
    },
    max: function(max) {
      return max * 1.2;
    }
  },
  dataLabels: {
    enabled: false
  },
  tooltip: {
    marker: false,
    x: {
      show: false
    },
    y: {
      formatter: function (value, { seriesIndex, dataPointIndex }) {
        if (seriesIndex === 0) {
          const cancelled = cancelledCalls[dataPointIndex];
          const completed = completedCalls[dataPointIndex];
          const unattended = unattendedCalls[dataPointIndex];
          const rescheduled = rescheduledCalls[dataPointIndex];

          return `
            <div class="flexDiv">
                <div class="custom-tooltip-item tooltipHeading">Total Calls: <span class="dashboardValue">${value}</span></div>
              
                <div class="flexColumn">
                  <div class="dataDiv">
                    <div class="custom-tooltip-item ">Cancelled: ${cancelled}</div>
                    <div class="custom-tooltip-item ">Completed: ${completed}</div>
                  </div>
                  <div class="dataDiv">
                    <div class="custom-tooltip-item ">No Show: ${unattended}</div>
                    <div class="custom-tooltip-item ">Rescheduled: ${rescheduled}</div>
                  </div>
                </div>

            </div>
          `;
        }
      }
    },
    enabled: true,
    style: {
      fontSize: '12px',
      fontFamily: undefined
    }
  }
};

return (
    <>
    {isLoaderFetching && <PageLoader />}
      <ErrorToast
        show={isShowError}
        setShow={() => setIsShowError(false)}
        message={errMessage}
      />
      <SuccessToast
      show={isShowSuccess}
      setShow={() => setIsShowSuccess(false)}
      message={successMessage}
    />
    <div className="AdDashboardMaindivwrap">
      <div className="AdCardMaindivWrap">

       <div className="dashboardFlexColumn">
        <div className="AdcardDatacontainer Wrapperforblock cardbordercolor">
            <div className="mnmtcountgraph flex gap-6">
              <h3 className='chartheading mb6'>{isDashboardFetching ? <Skeleton width={"100px"} /> : dashboardData?.menteeCount ?? 0}</h3>
              {/* <span className='mtsgrapg bggreen'><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.03457 5.15875C8.93957 5.15875 8.84457 5.12375 8.76957 5.04875L5.99957 2.27875L3.22957 5.04875C3.08457 5.19375 2.84457 5.19375 2.69957 5.04875C2.55457 4.90375 2.55457 4.66375 2.69957 4.51875L5.73457 1.48375C5.87957 1.33875 6.11957 1.33875 6.26457 1.48375L9.29957 4.51875C9.44457 4.66375 9.44457 4.90375 9.29957 5.04875C9.22957 5.12375 9.12957 5.15875 9.03457 5.15875Z" fill="#7BC896" />
                <path d="M6 10.6259C5.795 10.6259 5.625 10.4559 5.625 10.2509V1.83594C5.625 1.63094 5.795 1.46094 6 1.46094C6.205 1.46094 6.375 1.63094 6.375 1.83594V10.2509C6.375 10.4559 6.205 10.6259 6 10.6259Z" fill="#7BC896" />
              </svg>11%</span> */}
            </div>
            <p className='text2'>{isDashboardFetching ? <Skeleton width={"200px"} /> : "Total number of mentees"}</p>

            {/* <div className="AdgraphDesigncard">
              <ReactApexChart
                options={totalMenteeOptions}
                series={totalMenteeOptions.series}
                type="line"
                width="100%"
                height="150px"
              />
            </div> */}
          </div>

          <div className="AdcardDatacontainer Wrapperforblock cardbordercolor">
            <div className="mnmtcountgraph flex gap-6">
              <h3 className='chartheading mb6'>{isDashboardFetching ? <Skeleton width={"100px"} /> : dashboardData?.mentorCount ?? 0}</h3>
              {/* <span className='mtsgrapg bggreen'><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.03457 5.15875C8.93957 5.15875 8.84457 5.12375 8.76957 5.04875L5.99957 2.27875L3.22957 5.04875C3.08457 5.19375 2.84457 5.19375 2.69957 5.04875C2.55457 4.90375 2.55457 4.66375 2.69957 4.51875L5.73457 1.48375C5.87957 1.33875 6.11957 1.33875 6.26457 1.48375L9.29957 4.51875C9.44457 4.66375 9.44457 4.90375 9.29957 5.04875C9.22957 5.12375 9.12957 5.15875 9.03457 5.15875Z" fill="#7BC896" />
                <path d="M6 10.6259C5.795 10.6259 5.625 10.4559 5.625 10.2509V1.83594C5.625 1.63094 5.795 1.46094 6 1.46094C6.205 1.46094 6.375 1.63094 6.375 1.83594V10.2509C6.375 10.4559 6.205 10.6259 6 10.6259Z" fill="#7BC896" />
              </svg>  6% </span> */}
            </div>
            <p className='text2'>{isDashboardFetching ? <Skeleton width={"200px"} /> : 'Total number of mentors'}</p>

            {/* <div className="AdgraphDesigncard">
              <ReactApexChart
                options={totalMentorOptions}
                series={totalMentorOptions.series}
                type="line"
                width="100%"
                height="150px"
              />
            </div> */}
          </div>
       </div>

        <div className="AdCardSliderWrapper Wrapperforblock cardbordercolor">
          <div className='AdDsCardheading flex-between'>
            <div className="flex DsMentorheading">
              <h3 className='DsCradtext'>Mentor Requests {mentorRequests?.totalCount ? `(${mentorRequests?.totalCount})` : ''}</h3>
              <span className='textBlue viewallButton text2' onClick={() => {navigate("/admin/mentor-request"); dispatch(clearUsers())}} >View all</span>
            </div>
            <div className="arrowcardsDsAd flex">
              <img src="assets/img/arrowleft.png" alt="" className='pointer eqiconarrow' ref={navigationPrevRefds} />
              <img src="assets/img/arrowright.png" alt="" className='pointer eqiconarrow' ref={navigationNextRefds} />
            </div>
          </div>

          <Swiper
            slidesPerView={1}
            modules={[Navigation]}
            loop={false}
            spaceBetween={20}


            onSwiper={(swiper) => {
              // Delay execution for the refs to be defined
              setTimeout(() => {
                // Override prevEl & nextEl now that refs are defined
                swiper.params.navigation.prevEl = navigationPrevRefds.current
                swiper.params.navigation.nextEl = navigationNextRefds.current

                // Re-init navigation
                swiper.navigation.destroy()
                swiper.navigation.init()
                swiper.navigation.update()
              })
            }}
            navigation={{
              // Both prevEl & nextEl are null at render so this does not work
              prevEl: navigationPrevRefds.current,
              nextEl: navigationNextRefds.current,
            }}
            onBeforeInit={(swiper) => {
              swiper.navigation.nextEl = navigationNextRefds.current;
              swiper.navigation.prevEl = navigationPrevRefds.current;
            }}

            className="mySwiper">

            <div className='AdswiperWrappermain'>
              {isRequestsFetching ?
                <MnRequest name={<Skeleton width={"200px"} />} type={<Skeleton width={"50px"}/>} imgLoading={<Skeleton height={"50px"} width={"50px"} circle />}
                company={"Company: "} compdata={<Skeleton width={"100px"} />} exp={" Years of Experience: "} expdata={<Skeleton width={"100px"} /> } dom={"Functional focus area: "} domdata={<Skeleton width={"100px"} />}
                ment={"Mentoring On: "} mentdata={<Skeleton width={"100px"} />}
              /> :
              mentorRequests?.mentors?.length > 0 ? mentorRequests?.mentors.slice(0,10)?.map((item, index) => (
                <SwiperSlide key={index}>
                <MnRequest acceptreq={'acceptreq'} name={isRequestsFetching ? <Skeleton width={"200px"} /> : item?.firstName ? `${item?.firstName} ${item?.lastName}` : "---"} type={isRequestsFetching ? <Skeleton width={"50px"} /> : item?.profession?.designation ? item?.profession?.designation : "---"} linkedin={item?.linkedin?.slice(0,4) === "http" ? item?.linkedin : `https://${item?.linkedin}`}
                  company="Company: " compdata={isRequestsFetching ? <Skeleton width={"100px"} /> : item?.profession?.company ? item?.profession?.company : "---"} exp=" Years of Experience: " expdata={isRequestsFetching ? <Skeleton width={"100px"} /> : item?.profession?.yrsOfExp ? `${item?.profession?.yrsOfExp}+ years` : "---"} dom="Functional focus area: " domdata={isRequestsFetching ? <Skeleton width={"100px"} /> : item?.interests?.length > 0 ? item?.interests[0]?.interest : "---"}
                  ment="Mentoring On: " mentdata={isRequestsFetching ? <Skeleton width={"100px"} /> : item?.topics?.length > 0 ? item?.topics[0]?.Topic : "---"} onAccept={() => handleAcceptRequest(item?.id)} onReject={() => handleRejectRequest(item?.id)}
                />
              </SwiperSlide>
              )) : 
              "No Request yet"}
            </div>
          </Swiper>

        </div>

      </div>

      <div className="AdDashBoardMid">

        <div className="AdCardMaindivWrap">

          <div className="AdcardDatacontainer Wrapperforblock">
            <div className='flex-between CallAcAdtextwrap'>
              <div className="mainTexts">
                <h2 className="smallHeading heading-2">{isDashboardFetching ? <Skeleton width={"100px"} /> : 'Call Activity'}</h2>
                <p className="smallText text2">{isDashboardFetching ? <Skeleton width={"110px"} /> : 'Count of total calls :'}</p>
              </div>

              <div className="Multibtntabwrap flex gap-10">
                <div className={`btnweek ${duration === "week" && 'active'}`} onClick={() => setDuration("week")}>Week</div>
                <div className={`btnweek ${duration === "month" && 'active'}`} onClick={() => setDuration("month")} >Month</div>
                {/* <div className={`btnweek ${duration === "year" && 'active'}`} onClick={() => setDuration("year")}>Year</div> */}
              </div>
            </div>
            <div className="mnmtcountgraph flex gap-6">
              <h3 className='chartheading mb6'>{isDashboardFetching ? <Skeleton width={"50px"} /> : dashboardData?.totalCalls ?? 0}</h3>
              {/* <span className='mtsgrapg bggreen'><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.03457 5.15875C8.93957 5.15875 8.84457 5.12375 8.76957 5.04875L5.99957 2.27875L3.22957 5.04875C3.08457 5.19375 2.84457 5.19375 2.69957 5.04875C2.55457 4.90375 2.55457 4.66375 2.69957 4.51875L5.73457 1.48375C5.87957 1.33875 6.11957 1.33875 6.26457 1.48375L9.29957 4.51875C9.44457 4.66375 9.44457 4.90375 9.29957 5.04875C9.22957 5.12375 9.12957 5.15875 9.03457 5.15875Z" fill="#7BC896" />
                <path d="M6 10.6259C5.795 10.6259 5.625 10.4559 5.625 10.2509V1.83594C5.625 1.63094 5.795 1.46094 6 1.46094C6.205 1.46094 6.375 1.63094 6.375 1.83594V10.2509C6.375 10.4559 6.205 10.6259 6 10.6259Z" fill="#7BC896" />
              </svg>7% from last month</span> */}
            </div>

            <div className="AdgraphDesigncard">
            {isDashboardFetching ? 
            <div>
            {[...Array(5)].map((_, index) => (
              <Skeleton key={index} height={30} style={{ marginBottom: '10px' }} />
            ))}
          </div>
            :
            <>
            <ReactApexChart
              options={options}
              series={options.series}
              type="area"
              height={250}
              />

              {/* Week pagination */}
              {duration === "week" && 
                <div className='graphButton'>
                  <span className='text3 pointer' onClick={() => handleGraphPagination("prev","week")} >Prev week</span>
                  {week !== moment().format("YYYY-MM-DD") ? <span className='text3 pointer' onClick={() => handleGraphPagination("next","week")} >Next week</span> : <div></div>}
                </div>
              }

              {/* Month pagination */}
              {duration === "month" && 
                <div className="graphButton mt-10">
                  <span className='text3 pointer' onClick={() => handleGraphPagination("prev","month")} >Prev month</span>
                  <p className='text3'>{month ? moment().month(month).format("MMMM") : moment().format("MMMM")} 2023</p>
                  {month !== moment().month() ? <span className='text3 pointer' onClick={() => handleGraphPagination("next","month")} >Next month</span> : <div></div>}
                </div>
              }
              </> 
              }

            {/* <div id="custom-tooltip" className="custom-tooltip"></div> */}
            </div>
          </div>

          {/* <div className="AdcardDatacontainer Wrapperforblock">
            <div className="flex-between gap-6 flex-start">
              <div className="mainTexts">
                <h2 className="smallHeading heading-2">Performance</h2>
                <p className="smallText text2">21 Total Calls </p>
              </div>
              <label htmlFor="date" className='Cudatedesign'>
                <input type="date" id='date' />
              </label>
            </div>

            <div className="AdgraphDesigncard">
              <ReactApexChart
                options={options4}
                series={options4.series}
                type="area"
                width="100%"
                height="320px"
              />

              <div className="seriesTags flexbox">
                <div className="seriesText">Select Status to view response</div>
                <div className="tagsOPt green">Completed</div>
                <div className="tagsOPt blue">Rescheduled</div>
                <div className="tagsOPt red">Cancelled</div>
                <div className="tagsOPt purple">No show</div>
              </div>
            </div>
          </div> */}

        </div>

      </div>

      <div className="AdDashBoardBottom">
        <div className="AdCardMaindivWrap">

          {/* <div className="AdcardDatacontainer Wrapperforblock">

            <div className="mnmtcountgraph flex gap-6">

              <div className="mainTexts">
                <h2 className="smallHeading heading-2">Current Users</h2>
                <p className="smallText text2">Total number of users from past 6 months </p>
              </div>

              <h3 className='chartheading mb6'>231</h3>
              <span className='mtsgrapg bgpurple'>236 Mentors</span>
              <span className='mtsgrapg bgyellow'>117 Mentees</span>
            </div>

            <div className="AdgraphDesigncard">
              <ReactApexChart
                options={totalUsers}
                series={totalUsers.series}
                type="line"
                width="100%"
                height="265px"
              />
            </div>
          </div> */}

          <div className="AdcardDatacontainer Wrapperforblock">
            <div className="mnmtcountgraph flex gap-6 mb-20">
              <div className="mainTexts">
                <h2 className="smallHeading heading-2">Top Rated Mentors</h2>
                <p className="smallText text2">Average of mentors with top ratings</p>
              </div>
            </div>

            <div className="AdgraphDesigncard">
              <Swiper
                slidesPerView={1.5}
                spaceBetween={0}
                breakpoints={{
                  640: {
                    slidesPerView: 2,
                  },
                  768: {
                    slidesPerView: 3,
                  },

                  1024: {
                    slidesPerView: 4,
                  },
                  1700: {
                    slidesPerView: 6,
                  }
                }}
                pagination={{
                  clickable: true,
                }}
                modules={[Pagination, Navigation]}
                loop={false}
                className="mySwiper"

                onSwiper={(swiper) => {
                  // Delay execution for the refs to be defined
                  setTimeout(() => {
                    // Override prevEl & nextEl now that refs are defined
                    swiper.params.navigation.prevEl = navigationPrevRefNew.current
                    swiper.params.navigation.nextEl = navigationNextRefNew.current

                    // Re-init navigation
                    swiper.navigation.destroy()
                    swiper.navigation.init()
                    swiper.navigation.update()
                  })
                }}
                navigation={{
                  // Both prevEl & nextEl are null at render so this does not work
                  prevEl: navigationPrevRefNew.current,
                  nextEl: navigationNextRefNew.current,
                }}
                onBeforeInit={(swiper) => {
                  swiper.navigation.nextEl = navigationNextRefNew.current;
                  swiper.navigation.prevEl = navigationPrevRefNew.current;
                }}

              >

                <div className="NextBtn swiperbtn swiperBtnNew mobhide" ref={navigationPrevRefNew}>
                  <svg width="13" height="24" viewBox="0 0 13 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M12.3839 1.22677C12.872 1.71493 12.872 2.50638 12.3839 2.99454L3.26777 12.1107L12.3839 21.2268C12.872 21.7149 12.872 22.5064 12.3839 22.9945C11.8957 23.4827 11.1043 23.4827 10.6161 22.9945L0.616117 12.9945C0.127961 12.5064 0.127961 11.7149 0.616117 11.2268L10.6161 1.22677C11.1043 0.738618 11.8957 0.738618 12.3839 1.22677Z" fill="#737373" />
                  </svg>
                </div>

                {isTopRatedMentorFetching ?
                <div className='flex'>
                <CardDs imgLoading={<Skeleton circle height={"100px"} width={"100px"} />} rating={<Skeleton width={"30px"} />} name={<Skeleton width={"80px"} />} btn="View Profile" />
                <CardDs imgLoading={<Skeleton circle height={"100px"} width={"100px"} />} rating={<Skeleton width={"30px"} />} name={<Skeleton width={"80px"} />} btn="View Profile" />
                <CardDs imgLoading={<Skeleton circle height={"100px"} width={"100px"} />} rating={<Skeleton width={"30px"} />} name={<Skeleton width={"80px"} />} btn="View Profile" />
                <CardDs imgLoading={<Skeleton circle height={"100px"} width={"100px"} />} rating={<Skeleton width={"30px"} />} name={<Skeleton width={"80px"} />} btn="View Profile" />
                <CardDs imgLoading={<Skeleton circle height={"100px"} width={"100px"} />} rating={<Skeleton width={"30px"} />} name={<Skeleton width={"80px"} />} btn="View Profile" />
                <CardDs imgLoading={<Skeleton circle height={"100px"} width={"100px"} />} rating={<Skeleton width={"30px"} />} name={<Skeleton width={"80px"} />} btn="View Profile" />
                <CardDs imgLoading={<Skeleton circle height={"100px"} width={"100px"} />} rating={<Skeleton width={"30px"} />} name={<Skeleton width={"80px"} />} btn="View Profile" />
                </div>
                :
                 topMentorRatings?.map((item, index) => (
                  <SwiperSlide className='mentorSlider'>
                    <CardDs to={`/admin/mentor-profile/${item?.id}`} userimg={item?.profileImg ? item?.profileImg : "/assets/img/User.png"} rating={(+item?.averageRating).toFixed(0) ?? 0} name={item?.firstName ? `${item?.firstName} ${item?.lastName}` : "---"} btn="View Profile" />
                  </SwiperSlide>
                ))}


                <div className="PreBtn swiperbtn swiperBtnNew mobhide" ref={navigationNextRefNew}>
                  <svg width="13" height="24" viewBox="0 0 13 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M0.616117 1.22677C1.10427 0.738618 1.89573 0.738618 2.38388 1.22677L12.3839 11.2268C12.872 11.7149 12.872 12.5064 12.3839 12.9945L2.38388 22.9945C1.89573 23.4827 1.10427 23.4827 0.616117 22.9945C0.127961 22.5064 0.127961 21.7149 0.616117 21.2268L9.73223 12.1107L0.616117 2.99454C0.127961 2.50638 0.127961 1.71493 0.616117 1.22677Z" fill="#737373" />
                  </svg>
                </div>

              </Swiper>
            </div>
          </div>

        </div>
      </div>

    </div>
    </>
  )
}

export default Dashboard